// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-tab-nearest-poi {
  margin-top: 20px;
  padding-left: 15px;
  display: block;
}
wm-tab-nearest-poi .webmapp-title {
  font-weight: var(--wm-font-weight-bold);
  font-size: var(--wm-font-md);
}
wm-tab-nearest-poi .webmapp-track-poi-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-tab-nearest-poi .webmapp-track-poi-list .webmapp-track-poi-item {
  flex: 0 1 auto;
  align-self: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  margin-bottom: 10px;
  height: 60px;
  cursor: pointer;
}
wm-tab-nearest-poi .webmapp-track-poi-list .webmapp-track-poi-text {
  margin-left: 5px;
  flex: 1 1 auto;
  align-self: auto;
  height: 100%;
}
wm-tab-nearest-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
}
wm-tab-nearest-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-description {
  align-self: stretch;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  flex: 0 1 auto;
}
wm-tab-nearest-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-btns {
  margin-top: 5px;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}
wm-tab-nearest-poi .webmapp-track-poi-list wm-img {
  height: 100%;
  width: 108px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  object-fit: cover;
  min-height: unset;
  flex: 0 0 auto;
  align-self: auto;
}
wm-tab-nearest-poi .webmapp-track-poi-list wm-img img {
  border-radius: 8px;
}
wm-tab-nearest-poi .webmapp-track-poi-list .selected {
  background-color: rgb(243, 244, 246);
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/tab-nearest-poi/tab-nearest-poi.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AACF;AAAE;EACE,uCAAA;EACA,4BAAA;AAEJ;AAAE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AAEJ;AADI;EACE,cAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAEN;AAAI;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAEN;AAAM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAER;AACM;EACE,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,cAAA;AACR;AACM;EACE,eAAA;EAGA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AACR;AAGI;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,cAAA;EACA,gBAAA;AAFN;AAGM;EACE,kBAAA;AADR;AAII;EACE,oCAAA;EACA,kBAAA;AAFN","sourcesContent":["wm-tab-nearest-poi {\n  margin-top: 20px;\n  padding-left: 15px;\n  display: block;\n  .webmapp-title {\n    font-weight: var(--wm-font-weight-bold);\n    font-size: var(--wm-font-md);\n  }\n  .webmapp-track-poi-list {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    .webmapp-track-poi-item {\n      flex: 0 1 auto;\n      align-self: auto;\n\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: stretch;\n      margin-bottom: 10px;\n      height: 60px;\n      cursor: pointer;\n    }\n    .webmapp-track-poi-text {\n      margin-left: 5px;\n      flex: 1 1 auto;\n      align-self: auto;\n      height: 100%;\n\n      .webmapp-track-poi-title {\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 22px;\n        letter-spacing: 0em;\n        text-align: left;\n      }\n\n      .webmapp-track-poi-description {\n        align-self: stretch;\n        display: -webkit-box;\n        overflow: hidden;\n        -webkit-line-clamp: 4;\n        -webkit-box-orient: vertical;\n        flex: 0 1 auto;\n      }\n      .webmapp-track-poi-btns {\n        margin-top: 5px;\n        display: -ms-inline-flexbox;\n        display: -webkit-inline-flex;\n        display: inline-flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-content: stretch;\n        align-items: flex-start;\n      }\n    }\n\n    wm-img {\n      height: 100%;\n      width: 108px;\n      left: 0px;\n      top: 0px;\n      border-radius: 8px;\n      object-fit: cover;\n      min-height: unset;\n\n      flex: 0 0 auto;\n      align-self: auto;\n      img {\n        border-radius: 8px;\n      }\n    }\n    .selected {\n      background-color: rgba(243, 244, 246, 1);\n      border-radius: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
